const en_purch_poMitra = {

}

export default en_purch_poMitra;